// removed by extract-text-webpack-plugin
module.exports = {"drawerContent":"qempo_DotsDrawer_drawerContent-3lBGK2_","menuWrap":"qempo_DotsDrawer_menuWrap-1V_ul2o","separator":"qempo_DotsDrawer_separator-1dk9r3L","disabled":"qempo_DotsDrawer_disabled-36Ir6cF","orange":"qempo_DotsDrawer_orange-3eA62Wq","lightBlue":"qempo_DotsDrawer_lightBlue-2RHuN75","red":"qempo_DotsDrawer_red-3kxNFuh","drawerFooter":"qempo_DotsDrawer_drawerFooter-3FPYcbq"};


//////////////////
// WEBPACK FOOTER
// ./src/elements/DotsMenu/DotsDrawer/DotsDrawer.scss
// module id = 1356
// module chunks = 0